import { zSidLabel } from "src/types";

import { ZAttrMeta } from "../ZAttrMeta";
import { ZAttrValueRecord } from "../ZAttrValue";

export const attrValueInternalToRaw = (
  value: unknown,
  meta: ZAttrMeta,
): unknown => {
  // Здесь предполагается, что внутренние данные провалидированы
  // Поэтому преобразование необходимо лишь для списков
  if (meta.type.name === "list") {
    if (typeof value === "object" && value && meta.type.fields) {
      return cvtList(value as Record<string, unknown>, meta.type.fields);
    }
    return null;
  }
  if (meta.type.name === "strOption") {
    const res = zSidLabel.safeParse(value);
    return res.success ? res.data : null;
  }
  return value;
};

const cvtList = (
  srcList: Record<string, unknown>,
  fields: ZAttrMeta[],
): ZAttrValueRecord[] => {
  const result: ZAttrValueRecord[] = [];
  Object.values(srcList).forEach((record) => {
    if (record && typeof record === "object") {
      result.push(
        attrsRecordInternalToRaw(record as Record<string, unknown>, fields),
      );
    }
  });
  return result;
};

export const attrsRecordInternalToRaw = (
  srcRecord: Record<string, unknown>,
  fields: ZAttrMeta[],
): ZAttrValueRecord => {
  const dstRecord: ZAttrValueRecord = {};
  fields.forEach((field) => {
    dstRecord[field.name] = attrValueInternalToRaw(
      srcRecord[field.name],
      field,
    );
  });
  return dstRecord;
};
